import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.191 5.062C8.931 4.035 10.156 3.25 12 3.25s3.07.785 3.809 1.812c.711.988.941 2.151.941 2.938v3.25h.65c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H6.6a1.35 1.35 0 0 1-1.35-1.35v-6.8c0-.746.604-1.35 1.35-1.35h.65V8c0-.787.23-1.95.941-2.938m.559 6.188h6.5V8c0-.547-.17-1.383-.659-2.062-.46-.64-1.235-1.188-2.591-1.188s-2.13.548-2.591 1.188C8.92 6.617 8.75 7.453 8.75 8zm-2 1.5v6.5h10.5v-6.5z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }